import React from "react";
import { Container } from "react-bootstrap";
import "../App.css";

export default function CustomContainer({
  children,
  fluid = true,
  className = "",
  ...rest
}) {
  return (
    <Container fluid={fluid} className={`custom-container ${className}`} {...rest}>
      {children}
    </Container>
  );
}